// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NT2Bj","footerContent":"footer_footerContent__40Whi","poweredBy":"footer_poweredBy__IpX71","copyright":"footer_copyright__OK0v6"};